export const aboutInfo = {
  brandName: '吃瓜网站',
  tagline: '吃瓜网站首页入口直达，全网最全吃瓜平台',
  description: '吃瓜网站成立于2023年，是国内领先的娱乐八卦资讯聚合平台。整合51吃瓜网站、五一吃瓜网站等核心栏目，覆盖网红塌房、博主反差视频与网络热门事件最新爆料。我们致力于为用户提供一站式、实时更新的娱乐资讯浏览体验，让每一位用户都能第一时间吃到最新鲜的"瓜"。',
  mission: '我们的使命是打造中国最具影响力的娱乐资讯平台，以真实、快速、全面的内容服务广大吃瓜群众。我们坚持原创与聚合相结合的内容策略，既有一手独家爆料，也有全网热点整合，让用户不再需要在多个平台之间来回切换。',
  vision: '成为中文互联网最值得信赖的娱乐资讯平台，让"吃瓜"成为一种快乐、健康、有态度的生活方式。',
  stats: {
    totalArticles: '12,860',
    dailyUpdates: '200+',
    monthlyVisitors: '3800万',
    totalComments: '5.6亿',
    established: '2023',
    teamSize: '50+',
  },
  features: [
    {
      icon: 'ri-flashlight-line',
      title: '实时更新',
      description: '7×24小时不间断追踪全网热点，重大事件15分钟内即可上线报道。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '真实可靠',
      description: '严格的内容审核机制，多方交叉验证信息来源，确保每一条爆料的可信度。',
    },
    {
      icon: 'ri-stack-line',
      title: '全面覆盖',
      description: '涵盖网红塌房、博主反差、每日大赛、热门事件等多个栏目，一站式吃瓜体验。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '用户至上',
      description: '无广告干扰、加载速度快、界面清爽，致力于打造最佳的用户浏览体验。',
    },
  ],
  timeline: [
    { year: '2023年3月', event: '吃瓜网站正式上线，首月用户突破50万' },
    { year: '2023年8月', event: '整合51吃瓜网站资源，内容覆盖量翻倍' },
    { year: '2023年12月', event: '推出"每日大赛"栏目，成为平台王牌栏目' },
    { year: '2024年6月', event: '月活用户突破1000万，进入行业前三' },
    { year: '2024年10月', event: '上线"网红塌房"专栏，首月阅读量突破5亿' },
    { year: '2025年3月', event: '与五一吃瓜网站达成战略合作，内容版图再扩张' },
    { year: '2025年9月', event: '用户量突破5000万，成为行业标杆' },
    { year: '2026年1月', event: '月活用户达到3800万，累计文章超12000篇' },
  ],
  teamValues: [
    { title: '真实', description: '坚持内容真实性为第一原则，拒绝虚假爆料和标题党。' },
    { title: '快速', description: '热点事件第一时间响应，用速度赢得用户信任。' },
    { title: '全面', description: '多维度覆盖各类娱乐资讯，不遗漏任何一个"瓜"。' },
    { title: '有趣', description: '让吃瓜变成一种快乐的体验，轻松幽默但不失专业。' },
  ],
  contactInfo: {
    email: 'contact@chigua.example.com',
    wechat: 'chigua_official',
    weibo: '@吃瓜网站官方',
    address: '北京市朝阳区互联网产业园A座1508室',
  },
};

export const faqItems = [
  {
    question: '吃瓜网站的内容来源是什么？',
    answer: '我们的内容来源于两部分：一是平台自有的编辑团队和特约记者进行的原创报道与深度调查；二是对全网公开信息的聚合整理与核实报道。所有内容在发布前均经过编辑团队的审核，确保真实性和准确性。',
  },
  {
    question: '吃瓜网站与其他娱乐资讯平台有什么不同？',
    answer: '吃瓜网站最大的特点是"快、全、真"——快：重大事件15分钟内即可上线报道；全：整合51吃瓜网站、五一吃瓜网站等多个核心资源；真：坚持多方验证，不传谣不信谣。此外，我们坚持无广告的清爽阅读体验，让用户的注意力完全集中在内容上。',
  },
  {
    question: '如何获取吃瓜网站的最新地址？',
    answer: '我们建议您将吃瓜网站首页加入浏览器收藏夹。同时，您也可以关注我们的官方微博和微信公众号，获取最新地址更新通知。我们的域名稳定，如无特殊情况不会频繁变更。',
  },
  {
    question: '吃瓜网站是否有App？',
    answer: '目前吃瓜网站提供完善的移动端网页版体验，在手机浏览器中访问即可获得接近原生App的使用体验，支持添加到手机桌面。独立App正在开发中，敬请期待。',
  },
  {
    question: '如何在吃瓜网站上进行商务合作？',
    answer: '我们欢迎品牌合作、内容授权等多种形式的商务合作。请通过下方的商务合作表单提交您的合作意向和联系方式，我们的商务团队会在3个工作日内与您联系。您也可以直接发送邮件至 contact@chigua.example.com。',
  },
  {
    question: '如果发现平台内容有误，如何反馈？',
    answer: '我们非常重视内容的准确性。如果您发现任何内容存在事实性错误，请通过"关于我们"页面的联系方式或邮件与我们取得联系。一经核实，我们会在第一时间进行更正并标注更新说明。对于重大错误，我们还会公开致歉。',
  },
];